import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminArticleNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('article');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
